<template>
  <div class="content">
    <div class="container-fluid">


    <!-- <button type="button" class="btn btn-primary btn-small" @click="TestAlert()">Test Alert</button> -->
    <button type="button" class="btn btn-primary btn-small" @click="Toggle()">Add</button>

    <transition name="fade">



      <card v-if="ShowAddForm" class="AddForm">

      <form v-on:submit.prevent="Save()">

          <div class="row">
              <div class="col-md-12">
                <p class="Hide" style="float: right;" @click="Hide()"><i class="nc-icon nc-simple-remove"></i></p>
                <h4 slot="header" class="card-title">Add Member</h4>
              </div>
          </div>

          <div class="row">

            <div class="form-group col-md-6">

              <base-input type="tel"
                        label="Mobile"
                        placeholder="10 Digit Mobile Number"
                        v-model="user.Mobile"
                        required
                        v-on:keyup="CheckUserExists"
                        >
              </base-input>

            </div>
            <div class="col-md-6" v-if="!ShowOnlyMobile">
              <base-input type="email"
                        label="Email"
                        placeholder="Email"
                        v-model="user.Email"
                        required
                        >
              </base-input>
            </div>
          </div>


          <div class="row" v-if="!ShowOnlyMobile">
            <div class="col-md-4">
                  <slot name="label">
                    <label class="control-label">
                      Location
                    </label>
                  </slot>
                  <autocomplete
                    ref="autocomplete"
                    placeholder="Search Location"
                    :source="Locations"
                    input-class="form-control"
                    results-property="data"
                    @selected="SelectLocation"
                    >
                  </autocomplete>
            </div>

            <div class="col-md-4" >
              <base-input type="text"
                        label="First Name"
                        placeholder="First Name"
                        v-model="user.FirstName"
                        required
                        >
              </base-input>
            </div>

            <div class="col-md-4">
              <base-input type="text"
                        label="Last Name"
                        placeholder="Last Name"
                        v-model="user.LastName"
                        required
                        >
              </base-input>
            </div>

          </div>

          <div class="row" v-if="!ShowOnlyMobile">

            <div class="col-md-6">
                  <slot name="label">
                    <label class="control-label">
                      Access Type
                    </label>
                  </slot>

                  <autocomplete
                    ref="autocomplete"
                    placeholder="Search Access Type"
                    :source="TeamType"
                    input-class="form-control"
                    results-property="data"
                    @selected="SelectAccessType"
                    >
                  </autocomplete>
            </div>


            <div class="col-md-6">
              <base-input type="date"
                        label="Expires On"
                        placeholder=""
                        v-model="user.ExpiresOn"
                        required
                        >
              </base-input>
            </div>

          </div>


          <div class="text-center">
            <button type="submit" class="btn btn-primary btn-fill float-right">
              Save
            </button>
          </div>
          <div class="clearfix"></div>
        </form>

      </card>


      <card v-if="ShowEditForm" class="AddForm">

      <form v-on:submit.prevent="Edit()">

          <div class="row">
              <div class="col-md-12">
                <p class="Hide" style="float: right;" @click="Hide()"><i class="nc-icon nc-simple-remove"></i></p>
                <h4 slot="header" class="card-title">Edit Member</h4>
              </div>
          </div>

          <div class="row">

            <div class="form-group col-md-6">

              <base-input type="tel"
                        label="Mobile"
                        placeholder="10 Digit Mobile Number"
                        v-model="user.Mobile"
                        required
                        >
              </base-input>

            </div>
            <div class="col-md-6">
              <base-input type="email"
                        label="Email"
                        placeholder="Email"
                        v-model="user.Email"
                        required
                        >
              </base-input>
            </div>
          </div>


          <div class="row">
            <div class="col-md-4">
                  <slot name="label">
                    <label class="control-label">
                      Location
                    </label>
                  </slot>
                  <autocomplete
                    ref="autocomplete"
                    placeholder="Search Location"
                    :source="Locations"
                    input-class="form-control"
                    results-property="data"
                    @selected="SelectLocation"
                    required
                    >
                  </autocomplete>
            </div>

            <div class="col-md-4" >
              <base-input type="text"
                        label="First Name"
                        placeholder="First Name"
                        v-model="user.FirstName"
                        required
                        >
              </base-input>
            </div>

            <div class="col-md-4">
              <base-input type="text"
                        label="Last Name"
                        placeholder="Last Name"
                        v-model="user.LastName"
                        required
                        >
              </base-input>
            </div>

          </div>

          <div class="row">

            <div class="col-md-6">
                  <slot name="label">
                    <label class="control-label">
                      Access Type
                    </label>
                  </slot>

                  <autocomplete
                    ref="autocomplete"
                    placeholder="Search Access Type"
                    :source="TeamType"
                    input-class="form-control"
                    results-property="data"
                    @selected="SelectAccessType"
                    required
                    >
                  </autocomplete>
            </div>


            <div class="col-md-6">
              <base-input type="date"
                        label="Expires On"
                        placeholder=""
                        v-model="user.ExpiresOn"
                        required
                        >
              </base-input>
            </div>

          </div>


          <div class="text-center">
            <button type="submit" class="btn btn-primary btn-fill float-right">
              Save
            </button>
          </div>
          <div class="clearfix"></div>
        </form>

      </card>


    </transition>

      <!-- Show Table -->
      <div class="row" v-if="ShowTable">

            <div class="col-md-12 table1">
              <card class="strpied-tabled-with-hover">
              <!-- <card class="card-plain"> -->
                <template slot="header">
                  <h4 class="card-title">My Team</h4>
                  <!-- <p class="card-category">Here is a subtitle for this table</p> -->
                </template>
                <div class="table-responsive">

                    <table class="table table-hover table-sm" id="MyTeam">
                      <thead>
                        <slot name="columns">
                          <tr>
                            <th v-for="column in columns">{{column}}</th>
                          </tr>
                        </slot>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in List" :key="index">
                          <slot :row="item">

                            <td>

                                <div id="visitorPhoto" class="text-center" v-if="item.PhotoURL" @click="showPhoto(item);">
                                  <img :src='item.PhotoURL' class="userImage">
                                </div>

                                <div id="visitorPhoto" v-if="!item.PhotoURL" class="text-center">
                                  <img src="img/default-avatar.png" alt="" class="userImage">
                                  <!-- <i class="fa fa-user-circle-o fa-3x" aria-hidden="true"></i> -->
                                </div>
                                  
                            </td>
                            <td>{{item.FirstName}} {{item.LastName}}</td>
                            <td>{{item.Mobile}}</td>
                            <td>{{item.Email}}</td>
                            <td>{{item.Location}}</td>
                            <td>

                                <button type="button" class="btn-fill btn-small btn btn-primary" v-if="item.Status == 'Pending'">Pending</button>
                                <button type="button" class="btn-fill btn-small btn btn-success" v-if="item.Status == 'Approved'">Approved</button>                   
                                <button type="button" class="btn-fill btn-small btn btn-danger" v-if="item.Status == 'Expired'">Expired</button>
                                <button type="button" class="btn-fill btn-small btn btn-danger" v-if="item.Status == 'Denied'">Denied</button>

                            </td>

                            <td>{{item.RequestedOn | formatDate}}</td>
                            <td>{{item.ExpiresOn | formatDate}}</td>
                            <td>
                              {{item.AccessType}}
                            </td>

                            <td>

                                  <div class="custom-control custom-switch" v-if="item.InviteVisitors">
                                    <input type="checkbox" class="custom-control-input" id="customSwitch2" v-model="item.InviteVisitors" @click="DisableInviteVisitors(item.id)">
                                    <label class="custom-control-label" for="customSwitch2"></label>
                                  </div>                              


                                  <div class="custom-control custom-switch" v-if="!item.InviteVisitors">
                                    <input type="checkbox" class="custom-control-input" id="customSwitch3" v-model="item.InviteVisitors" @click="EnableInviteVisitors(item.id)">
                                    <label class="custom-control-label" for="customSwitch3"></label>
                                  </div>                              


                            </td>
                            <td>

                                  <div class="custom-control custom-switch" v-if="item.ShowScannerApp" @click="DisableShowScannerApp(item.id)">
                                    <input type="checkbox" class="custom-control-input" id="customSwitch4" v-model="item.ShowScannerApp" >
                                    <label class="custom-control-label" for="customSwitch4"></label>
                                  </div>                              


                                  <div class="custom-control custom-switch" v-if="!item.ShowScannerApp" @click="EnableShowScannerApp(item.id)">
                                    <input type="checkbox" class="custom-control-input" id="customSwitch5" v-model="item.ShowScannerApp" >
                                    <label class="custom-control-label" for="customSwitch5"></label>
                                  </div>                              


                            </td>
                            <td>{{item.CreatedOn | formatDate}}</td>
                            <td>{{item.LastUpdated | formatDate}}</td>

                        

<!--                             <td>

                              <div class="custom-control custom-switch" v-if="item.Active">
                                <input type="checkbox" class="custom-control-input" id="customSwitch10" @click="MakeInactive(item.id)" v-model="item.Active">
                                <label class="custom-control-label" for="customSwitch10"></label>
                              </div>                                                            

                              <div class="custom-control custom-switch" v-if="!item.Active">
                                <input type="checkbox" class="custom-control-input" id="customSwitch11" @click="MakeActive(item.id)" v-model="item.Active">
                                <label class="custom-control-label" for="customSwitch11"></label>
                              </div>                                                            

                            </td> -->

                            <td>
                              <i class="fa fa-pencil" aria-hidden="true" @click="EditSetup(item)"></i>
                              <i class="fa fa-trash" aria-hidden="true" @click="Delete(item)"></i>
                            </td>

                          </slot>
                        </tr>
                      </tbody>
                    </table>

                </div>
              </card>
            </div>
    
        </div>

      </div>


    </div>
  </div>
</template>
<script>
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import LTable from 'src/components/Table.vue'
  import { globalStore } from '../main.js';
  import { db } from '../main.js';
  import $ from 'jquery';
  import swal from 'sweetalert';
  import moment from 'moment';
  import axios from 'axios';

  import Autocomplete from 'vuejs-auto-complete';
  import VuePhoneNumberInput from 'vue-phone-number-input';
  // Require needed datatables modules
  require('datatables.net')

  // const tableColumns = ['Id', 'Name', 'Salary', 'Country', 'City']
  const tableColumns = ['Photo', 'Name', 'Mobile', 'Email', 'Location', 'Status', 'Requested On', 'Expires On', 'Check Out', 'Created On','Last Updated']
  const tableData = [
  // {
  //   id: 1,
  //   name: 'Dakota Rice',
  //   salary: '$36.738',
  //   country: 'Niger',
  //   city: 'Oud-Turnhout'
  // },
  // {
  //   id: 2,
  //   name: 'Minerva Hooper',
  //   salary: '$23,789',
  //   country: 'Curaçao',
  //   city: 'Sinaai-Waas'
  // },
  // {
  //   id: 3,
  //   name: 'Sage Rodriguez',
  //   salary: '$56,142',
  //   country: 'Netherlands',
  //   city: 'Baileux'
  // },
  // {
  //   id: 4,
  //   name: 'Philip Chaney',
  //   salary: '$38,735',
  //   country: 'Korea, South',
  //   city: 'Overland Park'
  // },
  // {
  //   id: 5,
  //   name: 'Doris Greene',
  //   salary: '$63,542',
  //   country: 'Malawi',
  //   city: 'Feldkirchen in Kärnten'
  // }
  ]

  export default {
    components: {
      LTable,
      ChartCard,
      StatsCard,
      Autocomplete,
      VuePhoneNumberInput
    },
    data () {
      return {
        // -----Add Team Member -------
        ShowOnlyMobile: true,
        UserExists: false,
        // ---- country code dropdown
        hasLoaderActive: false,
        hasErrorActive: false,
        defaultCountry: 'US', 
        preferredCountries: ['US', 'IN'],
        yourValue: '',
        // --- End of country code ------
        ShowAddForm: false,
        ShowEditForm: false,
        ShowTable: true, 
        ShowCheckList: true,
        CompanyId: '',
        List: [],
        Locations: [],
        TeamType: [
          {name: "One Time Access", id: "123123", val: "Single"},
          {name: "Multiple Access", id: "989879", val: "Multiple"},
        ],
        columns: [
          'Photo',
          'Name',
          'Mobile',
          'Email',
          'Location',
          'Status',
          'Requested On',
          'Expires On',
          'One Time / Multiple Entry',
          'Can invite Visitors?',
          'Show in tablet during Visitor Check In?',
          'Added On',
          'Last Updated',
          '',
        ],
        user: {
          MobileTemp: '',
          Mobile: ''
        },
        FormInfo: {}
      }
    },
    beforeMount(){
      console.log("beforeMount");
    },
    mounted(){
      console.log("Mounted");

      this.CompanyId = globalStore.AdminId
      console.log("CompanyId: "+this.CompanyId);

      // console.log("Country Code: "+globalStore.UserInfo.CountryCode);
      // this.user.Mobile = globalStore.UserInfo.CountryCode;
      // console.log(this.user.Mobile);

      this.GetMyTeam();
      this.GetLocations();

    },
    methods:{
      Toggle(){

            console.log("Toggle Add Form");

            if(this.ShowAddForm){
              this.ShowAddForm = false;
            }else{
              this.ShowAddForm = true;
            }

      },
      Hide(){

            if(this.ShowAddForm){
              this.ShowAddForm = false;
            }else{
              this.ShowAddForm = true;
            }
      },
    GetMyTeam(){

      $('#MyTeam').DataTable().destroy();
      console.log('Get My Team called...');

      //-------- fetch all users -------
      this.List = []

      db.collection('MyTeam')
        .where('CompanyId','==',this.CompanyId)
        .where('Active','==',true)
        .get()
        .then((snap) => {




          // let data = snap.docs;
          // console.log(data);
          snap.docs.forEach(doc => {
            // console.log("Doc is: " + doc.id);
            // console.log("Name is: " + doc.data().Name);

          var InviteVisitors = false;
          var ShowScannerApp = false;

          if(doc.data().InviteVisitors == 'Yes'){
            InviteVisitors = true;
          }

          if(doc.data().ShowScannerApp == 'Yes'){
            ShowScannerApp = true;
          }

            this.List.push({
              id: doc.id,
              UserId: doc.data().UserId,
              FirstName: doc.data().FirstName,
              LastName: doc.data().LastName,
              Mobile: doc.data().Mobile,
              Email: doc.data().Email,
              PhotoURL: doc.data().PhotoURL,
              Notes: doc.data().Notes,
              Verified: doc.data().Verified,
              Location: doc.data().Location,
              LocationId: doc.data().LocationId,
              CompanyId: doc.data().CompanyId,
              CompanyName: doc.data().CompanyName,
              CreatedOn: doc.data().CreatedOn,
              RequestedOn: doc.data().RequestedOn,
              ExpiresOn: doc.data().ExpiresOn,
              LastUpdated: doc.data().LastUpdated,
              Status: doc.data().Status,
              AccessType: doc.data().AccessType,

              ExpiresOn: doc.data().ExpiresOn,
              InviteVisitors: InviteVisitors, 
              
              ShowScannerApp: ShowScannerApp, 
              Notes: doc.data().Notes 
            });
          });

          setTimeout(()=>{
            console.log('My Team: ',this.List.length);
            console.log(JSON.stringify(this.List[0], null, 2));
            // this.ShowLoading = false;
            this.initializeDataTable();

            // this.Users.map((val)=>{
            //   if(val.UserApp == true){
            //     this.UserAppCount++;
            //   }
            // });

          },1000)

        })
        .catch((e) => {

          console.log('Error:', (e));

        });

    },
    SelectLocation(group){
      console.log("SelectLocation");
      console.log(group);
      this.user.Location = group.display;
      this.user.LocationId = group.value;
    },
    SelectAccessType(group){
      console.log("SelectAccessType");
      console.log(group);
      this.user.AccessType = group.selectedObject.val;
      console.log(this.user.AccessType);
    },
    CheckUserExists(){
      console.log(this.user.Mobile.length);

      if(this.user.Mobile.length == 10){
        console.log(this.user.Mobile);

      this.user.MobileTemp = globalStore.UserInfo.CountryCode+this.user.Mobile;
      console.log(this.user.MobileTemp);

            db.collection('Users')
              .where('Mobile','==',this.user.MobileTemp)
              .where('Active','==',true)
              .get()
              .then((snap) => {

                console.log("Users Found: "+snap.docs.length);

                if(snap.docs.length > 0){

                  this.UserExists = true;

                  console.log("User Exists");
                  console.log("Set User ID and User FN & LN");
                  console.log("UserInfo: "+snap.docs[0].data());
                
                  this.user.UserId = snap.docs[0].id;
                  this.user.Email = snap.docs[0].data().Email;
                  this.user.FirstName = snap.docs[0].data().FirstName;
                  this.user.LastName = snap.docs[0].data().LastName;

                  console.log(this.user.UserId);

                  this.ShowOnlyMobile = false;
                }else{

                  this.UserExists = false;

                  console.log("User Does Not Exist");
                  console.log("Create New");
                  this.ShowOnlyMobile = false;

                  // this.CreateUser();

                }

                // snap.docs.forEach(doc => {
                //   this.List.push({
                //     id: doc.id,
                //     ShowScannerApp: doc.data().ShowScannerApp, 
                //     Notes: doc.data().Notes 
                //   });
                // });

              })
              .catch((e) => {
                console.log('Find User Error:', (e));
              });


      }

    },
    CreateUser(){
      console.log("Create New User");

            var payload = {
              FirstName: this.user.FirstName,
              LastName: this.user.LastName,
              Mobile: this.user.MobileTemp,
              Gender: "",
              CountryCode: globalStore.UserInfo.CountryCode,
              Email: this.user.Email,
              PhotoURL: "",
              CreatedOn: moment().format(),
              Token: "",
              Verified: false,
              Version: 2,
              Active: true
            };

            console.log("Payload: "+payload);

             db.collection("Users")
            .add(payload)
            .then((res) => {
              console.log('New User Added - Success');

              console.log("New UserID: "+res.id);
              this.user.UserId = res.id;
              this.user.PhotoURL = "";

              console.log("Now Add to My Team...");

              this.AddToMyTeam();

            })
            .catch(error => {
                console.error("Error: ", error);
            });      


    },
    AddToMyTeam(){
      console.log("Add To My Team...");

      console.log(this.user);

             db.collection("MyTeam")
            .add(this.user)
            .then((res) => {
              console.log('Added to My Team - Success');

              console.log("New UserID: "+res.id);

                      this.ShowAddForm = false;

                      var msg = "Added Successfully"
                      this.notifyVue('top', 'center', msg, 'primary', 'nc-icon nc-check-2');
                      
                      var table = $('#MyTeam').DataTable();             
                      table.destroy();       


                      this.SendWelcomeEmail(this.user);
                      this.user = {};


                      setTimeout(()=>{
                        this.GetMyTeam();     
                      },250)


            })
            .catch(error => {
                console.error("Error: ", error);
            }); 



    },
    GetLocations(){

      this.ShowLoading = true;
      console.log('Get Locations');
      console.log("CompanyId: "+this.CompanyId)

      //-------- fetch all agents -------
      this.Locations = []

      db.collection('Location')
        .where("CompanyId","==",this.CompanyId)
        .where("Active","==",true)
        .get()
        .then((snap) => {

          // let data = snap.docs;
          // console.log(data);
          snap.docs.forEach(doc => {
            // console.log("Doc is: " + doc.id);


            var Email = "";

            if(doc.data().Email){
              Email = doc.data().Email;
            }

            var LastUpdated = "";

            if(doc.data().LastUpdated){
              LastUpdated = doc.data().LastUpdated;
            }

            this.Locations.push({
              id: doc.id,
              name: doc.data().Location,
              ContactPerson: doc.data().ContactPerson,
              Mobile: doc.data().Mobile,
              Email: Email,
              CompanyId: doc.data().CompanyId,
              CompanyName: doc.data().CompanyName,
              Address: " ",
              GoogleMapURL: " ",
              LastUpdated: LastUpdated,
              VisitPurpose: doc.data().VisitPurpose,
              Parameters: doc.data().Parameters,
              CreatedOn: doc.data().CreatedOn,
              Notes: doc.data().Notes,
              Active: doc.data().Active,
            });
          });

          setTimeout(()=>{
            console.log('Locations:',this.Locations.length);
          },200)


        })
        .catch((e) => {
          console.log('Error:', (e));
        });


    },
    Save(){
      console.log("Save - Add My Team");

      this.user.CompanyName = globalStore.CompanyName;
      this.user.CompanyId = this.CompanyId,
      this.user.Verified = false,
      this.user.Notes = "",
      this.user.CreatedOn = moment().format();
      this.user.RequestedOn = "";
      this.user.Status = "Approved";
      this.user.InviteVisitors = 'Yes';
      this.user.ShowScannerApp = 'Yes';
      this.user.Mobile = this.user.MobileTemp;
      this.user.Active = true;

      console.log("Mobile: "+this.user.Mobile);

      console.log(this.user);

      if(this.UserExists){

        console.log("User Already Exists...");
        this.AddToMyTeam();

      }else{
        console.log("User Does Not Exist");
        this.CreateUser();
      }




    },
    TestAlert(){

        swal("A wild Pikachu appeared! What do you want to do?", {
          buttons: {
            cancel: "Run away!",
            catch: {
              text: "Throw Pokéball!",
              value: "catch",
            },
            defeat: true,
          },
        })
        .then((value) => {
          switch (value) {
         
            case "defeat":
              swal("Pikachu fainted! You gained 500 XP!");
              break;
         
            case "catch":
              swal("Gotcha!", "Pikachu was caught!", "success");
              break;
         
            // default:
            //   swal("Got away safely!");
          }
        });


    },
    EditSetup(info){

      this.ShowEditForm = true;

      console.log(info);
      this.user = info;

    },
    Edit(){

      console.log("Save Edit: "+this.user);

        console.log("Edit Location");
        console.log(this.user);
        console.log("Id: "+this.user.id);
        this.user.LastUpdated = moment().format();

           db.collection("MyTeam")
          .doc(this.user.id)
          .update(this.user)
          .then(() => {
            console.log('Updated - Success');

                      this.ShowEditForm = false;
                      this.user = {};

                      var msg = "Updated Successfully"
                      this.notifyVue('top', 'center', msg, 'primary', 'nc-icon nc-check-2');
                      
                      var table = $('#MyTeam').DataTable();             
                      table.destroy();            

                      this.GetMyTeam();        

          })
          .catch(error => {
              console.error("Error: ", error);
          });



    },
    Delete(info){


        swal({
          title: "Are you sure?",
          text: "Once deleted, you will not be able to recover this record!",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        })
        .then((willDelete) => {
          if (willDelete) {

                  console.log("Delete");

                       db.collection("MyTeam")
                      .doc(info.id)
                      .delete()
                      .then(() => {
                        console.log('Delted - Success');

                                  var msg = "Poof! Deleted Successfully"
                                  this.notifyVue('top', 'center', msg, 'primary', 'nc-icon nc-check-2');
                                  
                                  var table = $('#MyTeam').DataTable();             
                                  table.destroy();            

                                  this.GetMyTeam();        

                      })
                      .catch(error => {
                          console.error("Error: ", error);
                      });


          } else {

          }
        });




    },
    notifyVue (verticalAlign, horizontalAlign, msg, type, icon) {
        // const color = Math.floor((Math.random() * 4) + 1)
        this.$notifications.notify(
          {
            message: msg,
            icon: icon,
            horizontalAlign: horizontalAlign,
            verticalAlign: verticalAlign,
            type: type
          })
    },  
    SendWelcomeEmail(val){

                var type = "";
                var date = moment(val.ExpiresOn).format('D MMM YYYY');

                if(val.AccessType == 'Single'){
                  type = "One Time Access";
                }else{
                  type = "Unlimited Access";
                }

                var msg = "Hi "+val.FirstName+",<br><br>"+val.CompanyName+" has added you to their team on Visity for contactless employee check-in. You now have <b>"+type+"</b> access to "+val.CompanyName+" and your access exipres on <b>"+date+"</b>. Click Here to download Visity - http://onelink.to/gkq4am.<br><br>Have a great day!<br>Team Visity";

                  var info = {
                    Email: val.Email,
                    Subject: "Welcome to Visity",
                    Message: msg
                  };

                  console.log("Email Payload: "+JSON.stringify(info, null, 2));
     
                      // // Send Verification via Email
                      axios.post("https://us-central1-visity-usa.cloudfunctions.net/widgets/send-email", info).then((res) => {
                        console.log(res);
                        var response = res;
                      }).catch((e) => {
                        console.log(e);
                      });

    },
    EnableInviteVisitors(id){

          db.collection("MyTeam")
          .doc(id)
          .update({InviteVisitors: 'Yes'})
          .then(() => {
            console.log('Updated - Success');

                      var msg = "Updated Successfully"
                      this.notifyVue('top', 'center', msg, 'primary', 'nc-icon nc-check-2');
                      
                      var table = $('#MyTeam').DataTable();             
                      table.destroy();            

                      this.GetMyTeam();        

          })
          .catch(error => {
              console.error("Error: ", error);
          });


    },
    DisableInviteVisitors(id){

      console.log("Disable InviteVisitors");
      console.log(id)

          db.collection("MyTeam")
          .doc(id)
          .update({InviteVisitors: 'No'})
          .then(() => {
            console.log('Updated - Success');

                      var msg = "Updated Successfully"
                      this.notifyVue('top', 'center', msg, 'primary', 'nc-icon nc-check-2');
                      
                      var table = $('#MyTeam').DataTable();             
                      table.destroy();            

                      this.GetMyTeam();        

          })
          .catch(error => {
              console.error("Error: ", error);
          });


    },
    EnableShowScannerApp(id){

          db.collection("MyTeam")
          .doc(id)
          .update({ShowScannerApp: 'Yes'})
          .then(() => {
            console.log('Updated - Success');

                      var msg = "Updated Successfully"
                      this.notifyVue('top', 'center', msg, 'primary', 'nc-icon nc-check-2');
                      
                      var table = $('#MyTeam').DataTable();             
                      table.destroy();            

                      this.GetMyTeam();        

          })
          .catch(error => {
              console.error("Error: ", error);
          });


    },
    DisableShowScannerApp(id){

      console.log("Disable InviteVisitors");
      console.log(id)

          db.collection("MyTeam")
          .doc(id)
          .update({ShowScannerApp: 'No'})
          .then(() => {
            console.log('Updated - Success');

                      var msg = "Updated Successfully"
                      this.notifyVue('top', 'center', msg, 'primary', 'nc-icon nc-check-2');
                      
                      var table = $('#MyTeam').DataTable();             
                      table.destroy();            

                      this.GetMyTeam();        

          })
          .catch(error => {
              console.error("Error: ", error);
          });


    },
      initializeDataTable(){
        console.log("initializeDataTabl")

        setTimeout(() => {
          this.$nextTick(() => {

            $("#MyTeam").DataTable({
              // sDom: '<"top"f>rt<"bottom"i><"clear">',
              // dom: 'ifBtlp',
              dom: 'frBtip',
              fixedHeader: true,
              buttons: [
                {
                  extend: "csvHtml5",
                  text: "EXPORT",
                  title: "DataTable"
                }
              ]
            });

          });
        }, 100);


      },           
    }
  }
</script>
<style scoped="">

  .stats{
    border: 1px solid #DCDCDC;
    border-radius: 0.5em;
  }

  .Label{
    color: #707070;
  }

  .table1{
    margin-top: 1em;
  }

.dt-button.buttons-csv.buttons-html5{
  margin-left: 20em;
  background: #00b33c;
  border: 1px solid #00b33c;
  color: #ffffff;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  padding-left: 1em;
  padding-right: 1em;
  border-radius: 0.5em;
}

#Visitors_filter.dataTables_filter{
    /*margin-left: 5em;*/
  }

  .nc-check-2{
    color: green;
  }

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}

.Hide{
  cursor: pointer;
}

.modal{
  z-index: 5;
}


</style>
